module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "elevation-2"
  }, [_c('v-toolbar', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "subtitle-1"
  }, [_vm._v(_vm._s(_vm.title) + " Comments")])], 1), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "background-color": "#fff"
    }
  }, [_c('v-card', {
    staticClass: "overflow-hidden overflow-y-auto",
    attrs: {
      "flat": "",
      "max-height": "300px"
    }
  }, [(_vm.messages.length > 0) ? _c('v-card-text', {
    staticStyle: {
      "padding": "0"
    }
  }, _vm._l((_vm.messages), function(msg, index) {
    return _c('element', {
      key: index
    }, [_c('p', {
      staticClass: "body-2 mb-1 font-weight-bold"
    }, [_vm._v(_vm._s(msg.author))]), _vm._v(" "), _c('p', {
      staticClass: "body-1 mb-1 font-weight-medium",
      domProps: {
        "innerHTML": _vm._s(_vm.renderHTML(msg.text))
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "caption text-xs-right font-italic"
    }, [_vm._v(_vm._s(_vm.getRelativeTime(msg.createdAt)))]), _vm._v(" "), _c('v-divider')], 1)
  }), 0) : _c('v-card-text', [_c('p', {
    staticClass: "body-1 mb-0 fong-weight-bold"
  }, [_vm._v("\n          No Comments\n        ")])])], 1), _vm._v(" "), (!_vm.readOnly) ? _c('v-card-actions', [_c('v-textarea', {
    staticStyle: {
      "max-height": "200px",
      "overflow-y": "auto"
    },
    attrs: {
      "outlined": "",
      "rows": "3",
      "auto-grow": "",
      "placeholder": "Write your comments here..."
    },
    model: {
      value: (_vm.messageText),
      callback: function($$v) {
        _vm.messageText = $$v
      },
      expression: "messageText"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (!_vm.readOnly) ? _c('v-btn', {
    attrs: {
      "block": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.sendMessage()
      }
    }
  }, [_vm._v("Add Comment")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4443e92e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Pairing/CreatorConceptForm/chatbox.vue
// module id = 2099
// module chunks = 0